import { QueryData } from '../runtime';

/**
 * Helper to get all formatted time series names across multiple queries
 */
export function extractFormattedSeriesNames(queryResults: Array<QueryData<'TimeSeries'>>): string[] {
  const seriesNames: string[] = [];
  for (let i = 0; i < queryResults.length; i++) {
    const result = queryResults[i];
    if (result && result.data) {
      const seriesArray = result.data.series;
      for (let j = 0; j < seriesArray.length; j++) {
        const series = seriesArray[j];
        if (series?.formattedName) {
          seriesNames.push(series.formattedName);
        }
      }
    }
  }
  return seriesNames;
}
